/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import * as actions from './UserPaymentMethod-Actions';

const initialState = {
    mostUsed: [],
    isUserSelectPaymentMethod: false,
    isPersonlaizedPaymentMethodSelected: false,
};

const userPaymentMethodReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.loadMostUsedPaymentMethods().type:
            return {
                ...state,
                mostUsed: action.data,
            };

        case actions.userSelectPaymentMethod().type:
            return { ...state, isUserSelectPaymentMethod: true, isPersonlaizedPaymentMethodSelected: false };

        case actions.selectPersonalizedPaymentMethod().type:
            return { ...state, isPersonlaizedPaymentMethodSelected: action.payload };

        default:
            return state;
    }
};

export default userPaymentMethodReducer;
